var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.359,
    height: 46.073,
    viewBox: "0 0 46.359 46.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.497,
    y1: 1,
    x2: 0.497,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b537d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76709a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8211",
    "data-name": "Path 8211",
    d: "M14.18,27.31H12.49l1.2-1.2a1,1,0,0,0-1.42-1.42l-1.19,1.2V24.2a1,1,0,1,0-2,0v1.69l-1.2-1.2a1,1,0,0,0-1.41,1.42l1.19,1.2H6a1,1,0,1,0,0,2H7.66L6.47,30.5a1,1,0,0,0,1.41,1.42l1.2-1.2v1.69a1,1,0,1,0,2,0V30.72l1.19,1.2a1,1,0,1,0,1.42-1.42l-1.2-1.19h1.69a1,1,0,1,0,0-2Z",
    fill: "#93eaf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8212",
    "data-name": "Path 8212",
    d: "M40.41,16.4h-.23a7.52,7.52,0,0,0,.18-1.59,7.28,7.28,0,0,0-7.28-7.28h0a7.26,7.26,0,0,0-1.82.24A11.59,11.59,0,0,0,8.78,10.39H8.71A8.71,8.71,0,0,0,0,19.1H0a8.71,8.71,0,0,0,8.71,8.71h31.7a5.71,5.71,0,1,0,0-11.41Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8213",
    "data-name": "Path 8213",
    d: "M28.84,40h-1.7l1.2-1.2a1,1,0,0,0-1.41-1.42l-1.2,1.2V36.84a1,1,0,0,0-2,0v1.69l-1.2-1.2a1,1,0,1,0-1.41,1.42l1.2,1.2h-1.7a1,1,0,1,0,0,2h1.7l-1.2,1.19a1,1,0,1,0,1.41,1.42l1.2-1.2v1.69a1,1,0,0,0,2,0V43.36l1.2,1.2a1,1,0,0,0,1.41-1.42L27.14,42h1.7a1,1,0,0,0,0-2Z",
    fill: "#93eaf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8214",
    "data-name": "Path 8214",
    d: "M27.64,25.33h-1.7l1.2-1.2a1,1,0,1,0-1.41-1.41l-1.2,1.2v-1.7a1,1,0,0,0-2,0v1.7l-1.2-1.2a1,1,0,1,0-1.41,1.41l1.2,1.2h-1.7a1,1,0,0,0,0,2h1.7l-1.2,1.2a1,1,0,0,0,1.41,1.41l1.2-1.19v1.69a1,1,0,0,0,2,0V28.75l1.2,1.19a1,1,0,0,0,1.41-1.41l-1.2-1.2h1.7a1,1,0,0,0,0-2Z",
    fill: "#93eaf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8215",
    "data-name": "Path 8215",
    d: "M41.19,29.25H39.5l1.2-1.2a1,1,0,1,0-1.42-1.41l-1.19,1.2v-1.7a1,1,0,0,0-2,0v1.7l-1.2-1.2a1,1,0,1,0-1.42,1.41l1.2,1.2H33a1,1,0,0,0,0,2h1.69l-1.2,1.2a1,1,0,0,0,1.42,1.41l1.2-1.2v1.7a1,1,0,0,0,2,0v-1.7l1.19,1.2a1,1,0,1,0,1.42-1.41l-1.2-1.2h1.69a1,1,0,1,0,0-2Z",
    fill: "#93eaf8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/Snow.de94842ede52c134834a56c9cbaa96e3.svg";
export { ForwardRef as ReactComponent };